export enum ResetPinStepsEnum {
  Auth = 'auth',
  PIN = 'pin',
  Done = 'done',
}
